import { TimelineGroup } from "../../../components/TimelineComponent";

export enum PositionStatusFilters {
  ALL = "All",
  ACTIVE = "Active",
  ACTIVE_AND_ASSIGNED = "Active and assigned",
}

interface FilterFunction {
  (item: TimelineGroup, hasAssignations: boolean): boolean;
}

export const FILTER_FUNCTIONS: Record<PositionStatusFilters, FilterFunction> = {
  [PositionStatusFilters.ALL]: () => true,
  [PositionStatusFilters.ACTIVE]: (group) => {
    const date = new Date();
    return group.start_time <= date && (group.end_time === undefined || date <= group.end_time);
  },
  [PositionStatusFilters.ACTIVE_AND_ASSIGNED]: (group, hasAssignations) => {
    const date = new Date();
    return hasAssignations && group.start_time <= date && (group.end_time === undefined || date <= group.end_time);
  },
};
